<template>
  <div class="form-container">
    <h1>
      管理{{ type }}--{{ activityMsg.city }}--{{ activityMsg.title }}--参会用户
    </h1>
    <el-table :data="tableShow">
      <el-table-column prop="id" label="参会人ID" />
      <el-table-column prop="company" label="公司名" />
      <el-table-column prop="name" label="姓名" />
      <el-table-column prop="job" label="职位" />
      <el-table-column prop="mail" label="邮箱" />
      <el-table-column prop="phone" label="手机号" />
      <el-table-column prop="wechat" label="微信号" />
      <el-table-column
        prop="sms"
        label="短信状态"
        :filters="[
          { text: '已发送', value: 'send' },
          { text: '未发送', value: 'notsend' }
        ]"
        :filter-method="filterStatus"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.sms == 'send'" class="need-passed">已发送</span>
          <span v-else class="need-pass"> 未发送 </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="randomKey"
        label="会前提醒"
        :filters="[
          { text: '已发送', value: '2' },
          { text: '未发送', value: '1' }
        ]"
        :filter-method="filterRandomKey"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.randomKey == '2'" class="need-passed"
            >已提醒</span
          >
          <span v-else class="need-pass"> 未提醒 </span>
        </template>
      </el-table-column>
      <el-table-column prop="card" label="名片">
        <template slot-scope="scope">
          <el-popover
            ref="scope"
            width="500"
            trigger="hover"
            placement="left-start"
            offset="12"
          >
            <img :src="scope.row.card" width="100%" />
            <el-button slot="reference" type="text">
              <a :href="scope.row.card" target="_blank"> 查看名片</a>
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="timeType" label="参会时间" />
      <el-table-column prop="status" label="审核状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" class="need-pass">待审核</span>
          <span v-else-if="scope.row.status == 1" class="need-passed"
            >通过审核</span
          >
          <span v-else class="need-failed">未通过审核</span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <!-- <el-button @click="editUser(scope.row.id)" type="text" size="small">编辑用户</el-button> -->
          <el-button
            @click="
              reSms(
                scope.row.id,
                scope.row.name,
                scope.row.phone,
                scope.row.phoneCode,
                scope.row.timeType,
                scope.row.acType
              )
            "
            type="text"
            size="small"
            v-if="scope.row.sms !== 'send'"
            >发送短信</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="normal-pagination">
      <el-pagination
        layout="total, prev, pager, next"
        :page-size="15"
        :total="total"
        style="float:right"
        @current-change="changePage"
      >
      </el-pagination>
    </div>
    <div class="send-all-user-container" style="display:none">
      <el-button type="primary" round @click="getExcel">
        下载已通知用户数据
      </el-button>
      <el-button type="primary" round @click="getAllChecked"
        >显示所有已审核用户</el-button
      >
      <el-button type="primary" round @click="getAllCheckednotsend"
        >显示未发短信用户</el-button
      >
      <el-button type="primary" round @click="getAllCheckedSend"
        >显示已发短信用户</el-button
      >
      <el-button type="primary" round @click="getAllCheckedNeedNotice"
        >显示未提醒用户</el-button
      >
      <el-button
        type="danger"
        round
        @click="sendMultiSms"
        :disabled="buttonStatus"
        >给当前页发送短信</el-button
      >
      <el-button
        type="danger"
        round
        @click="sendNotice"
        :disabled="buttonStatus"
        >给当前页发送提醒</el-button
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("zh-cn");
export default {
  data() {
    return {
      tableShow: [],
      tableData: [],
      activityMsg: {},
      buttonStatus: false,
      page: 1
    };
  },
  methods: {
    //过滤sms状态
    filterStatus(value, row) {
      return row.sms == value;
    },
    //过滤random'key
    filterRandomKey(value, row) {
      return row.randomKey == value;
    },
    //获取场次信息
    getActionInfo(type, id) {
      if (type === "hkstocks") {
        this.$http.hkstocks_detail(id).then(res => {
          if (res.data.statusCode === 200) {
            this.activityMsg = res.data.result;
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else if (type === "roadshow") {
        this.$http.roadshow_detail(id).then(res => {
          if (res.data.statusCode === 200) {
            this.activityMsg = res.data.result;
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else if (type === "freetalks") {
        this.$http.freetalks_detail(id).then(res => {
          if (res.data.statusCode === 200) {
            this.activityMsg = res.data.result;
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else if (type === "enroll") {
        this.$http.getEnrollDetail(id).then(res => {
          if (res.data.statusCode === 200) {
            this.activityMsg = res.data.result;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    reSms(id, user, phone, nationCode, timeType, acType) {
      const timeWeek = moment(this.activityMsg.startTime).format("dddd");
      const AMtimeDate = moment(this.activityMsg.startTime).format("HH:mm");
      const PMtimeDate = moment(this.activityMsg.expireTime).format("HH:mm");
      const timeDate = timeType === "am" ? AMtimeDate : PMtimeDate;
      let time = moment(this.activityMsg.startTime).format("YYYY年MM月DD日");

      let { position, job, title, city, address } = this.activityMsg;
      // 如果是enroll 活动就设置短信模板
      const tplId = acType === "enroll" ? 520472 : null;
      if (acType === "enroll") {
        position = `${address}`;
        time = moment(+this.activityMsg.signupTime).format(
          "YYYY年MM月DD日 HH:mm"
        );
      } else {
        title = `${title}·${city}站(${
          timeType === "am" ? "上午场" : "下午场"
        })`;
        position = `${position}（${address}）`;
        time = `${time}（${timeWeek}）`;
      }

      // console.log({
      //   title,
      //   time,
      //   timeDate,
      //   position,
      //   job,
      //   id,
      //   user,
      //   phone,
      //   nationCode,
      //   acid: this.id,
      //   timeWeek,
      //   address,
      //   smsType: "pass",
      //   tplId
      // });

      this.$http
        .qsmsService({
          title,
          time,
          timeDate,
          position,
          job,
          id,
          user,
          phone,
          nationCode,
          acid: this.id,
          timeWeek,
          address,
          smsType: "pass",
          tplId
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$notify({
              message: "发送短信成功~" + phone,
              type: "success",
              position: "bottom-right",
              duration: 5000
            });
            this.getAllCheckednotsend();
          } else {
            this.$message.error("发送短信出错" + res.data.result);
          }
        });
    },
    //获取所有已审核用户
    getAllChecked() {
      this.$notify({
        message: "(ｷ｀ﾟДﾟ´)!!正在尝试获取所有已审核用户",
        type: "success"
      });
      this.$http
        .meetingUser(this.type, this.id, ["send,notsend"], ["1"])
        .then(res => {
          this.tableData = [];
          if (res.data.statusCode === 200) {
            this.tableData = res.data.result;
          } else if (res.data.statusCode === 404) {
            this.$message.error("当前活动未有用户审核通过,请先前往用户审核");
          } else {
            this.$message.error(res.data.message + res.data.result);
          }
          this.changePage(this.page);
        });
    },
    //获取所有已审核且发送了短信的用户
    getAllCheckedSend() {
      this.$notify({
        message: "(ｷ｀ﾟДﾟ´)!!正在尝试获取所有已审核且发送了短信的用户",
        type: "success"
      });
      this.$http.meetingUser(this.type, this.id, ["send"], ["1"]).then(res => {
        this.tableData = [];
        if (res.data.statusCode === 200) {
          this.tableData = res.data.result;
        } else if (res.data.statusCode === 404) {
          this.$message.error("当前未有用户已发送短信");
        } else {
          this.$message.error(res.data.message + res.data.result);
        }
        this.changePage(this.page);
      });
    },
    //获取所有已审核但是没发短信的用户
    getAllCheckednotsend() {
      this.$notify({
        message: "(ｷ｀ﾟДﾟ´)!!正在尝试获取所有已审核但没发短信的用户",
        type: "success"
      });
      this.$http
        .meetingUser(this.type, this.id, ["notsend"], ["1"])
        .then(res => {
          this.tableData = [];
          if (res.data.statusCode === 200) {
            this.tableData = res.data.result;
          } else if (res.data.statusCode === 404) {
            this.$message.error("当前未有已审核用户未发送短信");
          } else {
            this.$message.error(res.data.message + res.data.result);
          }
          this.changePage(this.page);
        });
    },
    //获取未提醒用户
    getAllCheckedNeedNotice() {
      this.$notify({
        message: "(ｷ｀ﾟДﾟ´)!!正在尝试获取所有已审核未提醒用户",
        type: "success"
      });
      this.$http
        .meetingUser(this.type, this.id, ["send,notsend"], ["1"])
        .then(res => {
          this.tableData = [];
          if (res.data.statusCode === 200) {
            this.tableData = res.data.result.filter(
              item => item.randomKey == 1
            );
          } else if (res.data.statusCode === 404) {
            this.$message.error("当前活动未有用户审核通过,请先前往用户审核");
          } else {
            this.$message.error(res.data.message + res.data.result);
          }
          this.changePage(this.page);
        });
    },
    changePage(id) {
      this.page = id;
      const start = (id - 1) * 15;
      const end = start + 15;
      this.tableShow = this.tableData.slice(start, end);
    },
    //给当前未审核用户发短信
    sendMultiSms() {
      this.buttonStatus = true;
      const users = this.tableShow.filter(item => {
        return item.sms !== "send";
      });
      if (users.length === 0) {
        this.$notify({
          title: "警告",
          message: "当前页面无未发送短信用户(‾⌣‾ԅ)",
          type: "warning"
        });
        this.buttonStatus = false;
        return;
      }
      const result = users.map(item => {
        let timeType = item.timeType;
        const timeWeek = moment(this.activityMsg.startTime).format("dddd");
        const AMtimeDate = moment(this.activityMsg.startTime).format("HH:mm");
        const PMtimeDate = moment(this.activityMsg.expireTime).format("HH:mm");
        const timeDate = timeType === "am" ? AMtimeDate : PMtimeDate;
        let time = moment(this.activityMsg.startTime).format("YYYY年MM月DD日");
        let { position, job, title, city, address } = this.activityMsg;
        title = `${title}·${city}站(${
          timeType === "am" ? "上午场" : "下午场"
        })`;
        position = `${position}（${address}）`;
        time = `${time}（${timeWeek}）`;
        const { id, name, phone, phoneCode } = item;
        return this.$http.qsmsService({
          title,
          id,
          job,
          name,
          phone,
          nationCode: phoneCode,
          time,
          timeWeek,
          timeDate,
          smsType: "pass",
          acid: this.id,
          position,
          address
        });
      });

      Promise.all([...result])
        .then(res => {
          console.log(res);
          const count = res.filter(item => item.data.statusCode === 200);
          console.log(count);
          this.$notify({
            message: "发送短信成功~,成功数量" + count.length,
            type: "success",
            position: "bottom-right",
            duration: 0
          });
          //获取未发送短信的用户
          this.getAllCheckednotsend().then(res => {
            this.buttonStatus = false;
            this.changePage(this.page);
          });
        })
        .catch(e => {
          this.buttonStatus = false;
        });
    },
    getExcel() {
      window.open(`/acapi/file/users/${this.type}/${this.id}/send/1`);
    },
    //给已审核用户发送参会提醒
    sendNotice() {
      this.buttonStatus = true;
      const users = this.tableShow.filter(item => item.randomKey != 2);
      if (users.length === 0) {
        this.$notify({
          title: "警告",
          message: "当前页面无未发送短信提醒用户(‾⌣‾ԅ)",
          type: "warning"
        });
        this.buttonStatus = false;
        return;
      }
      const result = users.map(item => {
        let timeType = item.timeType;
        const timeWeek = moment(this.activityMsg.startTime).format("dddd");
        const AMtimeDate = moment(this.activityMsg.startTime).format("HH:mm");
        const PMtimeDate = moment(this.activityMsg.expireTime).format("HH:mm");
        const timeDate = timeType === "am" ? AMtimeDate : PMtimeDate;
        let time = moment(this.activityMsg.startTime).format("YYYY年MM月DD日");
        let { position, job, title, city, address } = this.activityMsg;
        // title = `${title}·${city}站(${
        //   timeType === "am" ? "上午场" : "下午场"
        // })`;
        // position = `${position}（${address}）`;
        // time = `${time}（${timeWeek}）`;
        const tplId = this.$route.params.type === "enroll" ? 520472 : null;
        if (this.$route.params.type === "enroll") {
          position = `${address}`;
          time = moment(+this.activityMsg.signupTime).format(
            "YYYY年MM月DD日 HH:mm"
          );
        } else {
          title = `${title}·${city}站(${
            timeType === "am" ? "上午场" : "下午场"
          })`;
          position = `${position}（${address}）`;
          time = `${time}（${timeWeek}）`;
        }
        const { id, phone, phoneCode, nationCode } = item;
        console.log({
          smsType: "notice",
          id,
          title,
          phone,
          time,
          timeWeek,
          timeDate,
          position,
          address,
          nationCode: phoneCode
        });
        return;
        return this.$http.qsmsService({
          smsType: "notice",
          id,
          title,
          phone,
          time,
          timeWeek,
          timeDate,
          position,
          address,
          nationCode: phoneCode,
          tplId
        });
      });

      Promise.all([...result])
        .then(res => {
          const count = res.filter(item => item.data.statusCode === 200);
          console.log(count);
          this.$notify({
            message: "发送短信成功~,成功数量" + count.length,
            type: "success",
            position: "bottom-right",
            duration: 0
          });
          this.getAllCheckedNeedNotice().then(res => {
            this.buttonStatus = false;
            this.changePage(this.page);
          });
        })
        .catch(e => {
          this.buttonStatus = false;
        });
    }
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    id() {
      return this.$route.params.id;
    },
    total() {
      return this.tableData.length;
    }
  },
  mounted() {
    this.getActionInfo(this.type, this.id);
    this.getAllCheckednotsend();
  }
};
</script>
<style scoped>
.need-pass {
  color: #fa5555;
}

.need-passed {
  color: #67c23a;
}

.need-failed {
  color: #878d99;
}

.normal-pagination {
  overflow: hidden;
}

.send-all-user-container {
  float: right;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/sms.vue